import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class PostContentImageFallbackForm extends FormBase {
    public getClosestPostContent(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(
            root,
            `[data-role="${Roles.POST_CONTENT_DISPLAY}"], [data-role="${Roles.POST_DETAIL_CONTENT}"]`,
            HTMLElement,
        );
    }

    public getClosestSnsContent(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_CONTENT}"]`, HTMLElement);
    }

    public getContentImages(root: ParentNode): HTMLImageElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.POST_CONTENT_DISPLAY}"] img, [data-role="${Roles.POST_DETAIL_CONTENT}"] img`,
            HTMLImageElement,
        );
    }
}

const postContentImageFallbackForm = new PostContentImageFallbackForm();

export { postContentImageFallbackForm };
